export enum LoadDirectionEnum {
  INIT = "init",
  NEXT = "next",
  PREV = "prev",
}
